import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { UserProfileService } from '../user-profile.service';
import { getFirstSegmentOfPathName } from 'ngx-register-base';
import { getErrorMsg } from '../../utils/error-handling';
import { EDeclarationRoutes } from '../../constants/routes.constants';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard implements CanActivate {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloakService: KeycloakService,
    protected readonly userProfileService: UserProfileService
  ) {
    super(router, keycloakService);
  }

  async isAccessAllowed(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (!this.authenticated) {
      await this.keycloakService.login({
        redirectUri: window.location.origin + state.url,
      });
    }

    const firstSegmentOfPathName = getFirstSegmentOfPathName(state.url);

    if (!this.userProfileService.hasMenuPath(firstSegmentOfPathName)) {
      this.router.navigate([EDeclarationRoutes.DEFAULT]).catch(getErrorMsg);
    }

    return this.authenticated;
  }
}
